import { adminWorkspaceQueryKeys as e } from "./adminWorkspaceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspaceAdminApi as n } from "@maat/api-main";
//#region src/workspaces/admin/useAdminWorkspacePropertyStatsQuery.ts
var r = (r) => t({
	queryKey: e.propertyStats(r),
	queryFn: () => n.getPropertyStats(r),
	enabled: !!r
});
//#endregion
export { r as useAdminWorkspacePropertyStatsQuery };
